module.exports = __webpack_public_path__ + "static/media/Jeevan.e85416dc.png";